import React from 'react'

export function HomeDisclaimerSection() {
  return (
    <section className="px-6 py-8">
      <div className="mx-auto max-w-3xl text-center">
        <p className="text-xs text-foreground/60 italic">
          {
            'Conte\u00fado informativo e educacional. N\u00e3o constitui recomenda\u00e7\u00e3o de investimento, compra/venda ou promessa de retorno. Criptoativos envolvem riscos.'
          }
        </p>
      </div>
    </section>
  )
}

export default HomeDisclaimerSection

